import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import Pagination from '../components/Pagination';
import { situacaoExameLabel } from '../utils/situacaoExame';
import './DataPage.css';
import { formatDate, formatDateTime } from '../utils/formatDate';

const styles = {
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: { fontSize: '1.5rem', lineHeight: 1 },
  pageTitle: { fontSize: '1.5rem', fontWeight: '700', color: '#1a1a2e', margin: '0 0 2px 0' },
  pageSubtitle: { fontSize: '0.85rem', color: '#666', margin: 0 },
  // Filters
  filterBar: {
    display: 'flex',
    gap: '8px',
    marginBottom: '16px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  filterInput: {
    padding: '8px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.85rem',
    color: '#333',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  filterSelect: {
    padding: '8px 12px',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '0.85rem',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
  },
  // Table cells
  localBadge: {
    display: 'inline-block',
    padding: '3px 8px',
    borderRadius: '4px',
    fontSize: '0.8rem',
    fontWeight: '600',
    backgroundColor: '#f1f5f9',
    color: '#475569',
  },
  protocolo: { fontSize: '1rem', fontWeight: '600', color: '#2563eb' },
  protocoloSub: { fontSize: '0.72rem', color: '#9ca3af', marginTop: '1px' },
  pacienteNome: { fontSize: '0.95rem', fontWeight: '600', color: '#1f2937' },
  pacienteMeta: { fontSize: '0.8rem', color: '#6b7280', marginTop: '2px' },
  dataMain: { fontWeight: '600', fontSize: '0.85rem', color: '#374151' },
  dataSub: { fontSize: '0.78rem', color: '#9ca3af', marginTop: '1px' },
  // Progress bar for exames
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  progressBar: {
    flex: 1,
    height: '6px',
    backgroundColor: '#f1f5f9',
    borderRadius: '3px',
    overflow: 'hidden',
    minWidth: '50px',
  },
  progressText: { fontSize: '0.78rem', fontWeight: '600', color: '#374151', whiteSpace: 'nowrap' },
  // Status badge
  badgeConcluido: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: '600',
    backgroundColor: '#dcfce7',
    color: '#166534',
    cursor: 'pointer',
  },
  badgePendente: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: '600',
    backgroundColor: '#fef3c7',
    color: '#92400e',
    cursor: 'pointer',
  },
  // Action buttons
  btnActions: { display: 'flex', gap: '4px', alignItems: 'center' },
  btnLaudo: {
    padding: '5px 10px',
    fontSize: '0.78rem',
    fontWeight: '500',
    backgroundColor: '#eff6ff',
    color: '#2563eb',
    border: '1px solid #bfdbfe',
    borderRadius: '5px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s',
  },
  btnPdf: {
    padding: '5px 10px',
    fontSize: '0.78rem',
    fontWeight: '500',
    backgroundColor: '#f0fdf4',
    color: '#16a34a',
    border: '1px solid #bbf7d0',
    borderRadius: '5px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.15s',
  },
  btnPdfDisabled: {
    padding: '5px 10px',
    fontSize: '0.78rem',
    fontWeight: '500',
    backgroundColor: '#f9fafb',
    color: '#d1d5db',
    border: '1px solid #e5e7eb',
    borderRadius: '5px',
    cursor: 'default',
    whiteSpace: 'nowrap',
  },
  btnPesquisar: {
    padding: '8px 20px',
    backgroundColor: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: '600',
    whiteSpace: 'nowrap',
  },
  // Modal
  modalOverlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.35)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 9999,
  },
  modalBox: {
    background: '#fff', borderRadius: '10px', padding: '1.25rem',
    maxWidth: '520px', width: '92%', maxHeight: '80vh', overflow: 'auto',
    boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
  },
  modalHeader: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    marginBottom: '0.75rem', paddingBottom: '0.75rem', borderBottom: '1px solid #e5e7eb',
  },
  modalTitle: { margin: 0, fontSize: '1rem', fontWeight: '600', color: '#1e293b' },
  modalClose: {
    background: 'none', border: 'none', fontSize: '1.25rem',
    cursor: 'pointer', color: '#9ca3af', padding: '4px',
  },
  modalTable: { width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' },
  modalTh: { textAlign: 'left', padding: '6px 8px', color: '#6b7280', fontWeight: '600', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.3px', borderBottom: '2px solid #e5e7eb' },
  modalTd: { padding: '6px 8px', borderBottom: '1px solid #f3f4f6' },
  modalBadge: (ok) => ({
    fontSize: '0.7rem', padding: '2px 7px', borderRadius: '10px',
    background: ok ? '#dcfce7' : '#fef2f2',
    color: ok ? '#166534' : '#991b1b',
    fontWeight: '500',
  }),
  modalFooter: {
    marginTop: '0.75rem', paddingTop: '0.5rem', borderTop: '1px solid #e5e7eb',
    display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap',
    gap: '6px', fontSize: '0.75rem', color: '#6b7280',
  },
};

function Resultados() {
  const navigate = useNavigate();
  const [resultados, setResultados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [totalItems, setTotalItems] = useState(0);
  const [statusStats, setStatusStats] = useState([]);
  const [totais, setTotais] = useState({});
  const [search, setSearch] = useState('');
  const [statusResultado, setStatusResultado] = useState('');

  const getDefaultDates = () => {
    const hoje = new Date();
    const dataFim = hoje.toISOString().split('T')[0];
    const dataInicio = new Date(hoje.setDate(hoje.getDate() - 30)).toISOString().split('T')[0];
    return { dataInicio, dataFim };
  };

  const [dataInicio, setDataInicio] = useState(getDefaultDates().dataInicio);
  const [dataFim, setDataFim] = useState(getDefaultDates().dataFim);

  // Initial fetch on mount
  useEffect(() => {
    fetchResultados();
  }, []);

  // Auto-fetch on pagination changes
  useEffect(() => {
    fetchResultados();
  }, [currentPage, itemsPerPage]);

  const handleSearch = () => {
    setCurrentPage(1);
    fetchResultados();
  };

  const fetchResultados = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({ page: currentPage.toString(), limit: itemsPerPage.toString() });
      if (search) params.append('search', search);
      if (dataInicio) params.append('dataInicio', dataInicio);
      if (dataFim) params.append('dataFim', dataFim);
      if (statusResultado) params.append('statusResultado', statusResultado);

      const response = await axios.get(`${API_URL}/resultados?${params.toString()}`);
      const { data, total, statusStats: stats, totais: totaisData } = response.data;
      setResultados(data);
      setTotalItems(total);
      setStatusStats(stats || []);
      setTotais(totaisData || {});
    } catch (error) {
      console.error('Erro ao buscar resultados:', error);
    } finally {
      setLoading(false);
    }
  };

  const calcularIdade = (dataNascimento) => {
    if (!dataNascimento) return null;
    const hoje = new Date();
    const nascimento = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();
    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) idade--;
    return idade;
  };

  const formatCPF = (cpf) => {
    if (!cpf) return null;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const [downloadingPdf, setDownloadingPdf] = useState({});
  const [examesStatusModal, setExamesStatusModal] = useState(null);

  const handleClickStatus = async (atendimentoId, protocolo) => {
    setExamesStatusModal({ atendimentoId, protocolo, exames: [], loading: true });
    try {
      const response = await axios.get(`${API_URL}/resultados/${atendimentoId}/exames-status`);
      setExamesStatusModal({ atendimentoId, protocolo, exames: response.data, loading: false });
    } catch {
      setExamesStatusModal(prev => prev ? { ...prev, loading: false } : null);
    }
  };

  const situacaoLabel = situacaoExameLabel;

  const handleDownloadPdf = async (local, protocolo) => {
    const key = `${local}-${protocolo}`;
    setDownloadingPdf(prev => ({ ...prev, [key]: true }));
    try {
      const response = await axios.get(`${API_URL}/laudos/download/${local}/${protocolo}`, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (error) {
      const msg = error.response?.data?.error || error.response?.data?.message || 'Erro ao baixar PDF';
      alert(typeof msg === 'string' ? msg : 'Erro ao baixar PDF do laudo');
    } finally {
      setDownloadingPdf(prev => ({ ...prev, [key]: false }));
    }
  };

  if (loading) {
    return <div className="loading">Carregando resultados...</div>;
  }

  return (
    <div className="page-container data-page">
      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>🧪</span>
          <div>
            <h1 style={styles.pageTitle}>Resultados de Exames</h1>
            <p style={styles.pageSubtitle}>Visualize e imprima laudos de exames</p>
          </div>
        </div>
      </div>

      {/* Filtros */}
      <div style={styles.filterBar}>
        <input
          type="text"
          placeholder="Buscar protocolo, nome ou CPF..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') handleSearch(); }}
          style={{ ...styles.filterInput, flex: 1, minWidth: '240px' }}
        />
        <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} style={styles.filterInput} />
        <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)} style={styles.filterInput} />
        <select value={statusResultado} onChange={(e) => setStatusResultado(e.target.value)} style={{ ...styles.filterSelect, minWidth: '160px' }}>
          <option value="">Todos os Status</option>
          <option value="completo">Concluidos</option>
          <option value="pendente">Pendentes</option>
          <option value="parcial">Parciais</option>
        </select>
        <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))} style={styles.filterSelect}>
          <option value="10">10/pag</option>
          <option value="20">20/pag</option>
          <option value="50">50/pag</option>
          <option value="100">100/pag</option>
        </select>
        <button style={styles.btnPesquisar} onClick={handleSearch}>
          Pesquisar
        </button>
      </div>

      {/* Stats */}
      <div className="compact-stats">
        <div className="compact-stat-card blue">
          <div className="compact-stat-value">{(totais.totalAtendimentos || 0).toLocaleString('pt-BR')}</div>
          <div className="compact-stat-label">Atendimentos</div>
        </div>
        <div className="compact-stat-card green">
          <div className="compact-stat-value">{(totais.totalConcluidos || 0).toLocaleString('pt-BR')}</div>
          <div className="compact-stat-label">Concluidos</div>
        </div>
        <div className="compact-stat-card orange">
          <div className="compact-stat-value">{(totais.totalComPendencias || 0).toLocaleString('pt-BR')}</div>
          <div className="compact-stat-label">Com Pendencias</div>
        </div>
        <div className="compact-stat-card purple">
          <div className="compact-stat-value">{(totais.totalExames || 0).toLocaleString('pt-BR')}</div>
          <div className="compact-stat-label">Total Exames</div>
        </div>
        <div className="compact-stat-card teal">
          <div className="compact-stat-value">{(totais.totalResultados || 0).toLocaleString('pt-BR')}</div>
          <div className="compact-stat-label">Resultados</div>
        </div>
        <div className="compact-stat-card red">
          <div className="compact-stat-value">{(totais.totalPendentes || 0).toLocaleString('pt-BR')}</div>
          <div className="compact-stat-label">Pendentes</div>
        </div>
      </div>

      {/* Desktop: Tabela */}
      <div className="table-card">
        <div className="table-responsive resultados-desktop">
          <table className="data-table compact-table">
            <thead>
              <tr>
                <th style={{ width: '55px', textAlign: 'center' }}>Local</th>
                <th style={{ width: '100px' }}>Protocolo</th>
                <th>Paciente</th>
                <th style={{ width: '100px' }}>Data</th>
                <th style={{ width: '140px' }}>Exames</th>
                <th style={{ width: '85px', textAlign: 'center' }}>Status</th>
                <th style={{ width: '150px' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {resultados.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
                    Nenhum resultado encontrado
                  </td>
                </tr>
              ) : (
                resultados.map((resultado) => {
                  const totalExames = resultado.TOTAL_EXAMES || 0;
                  const totalResultados = resultado.TOTAL_RESULTADOS || 0;
                  const totalPendentes = totalExames - totalResultados;
                  const concluido = totalExames > 0 && totalResultados === totalExames;
                  const pct = totalExames > 0 ? Math.round((totalResultados / totalExames) * 100) : 0;
                  const pdfKey = `${resultado.LOCAL}-${resultado.PROTOCOLO}`;
                  const idade = calcularIdade(resultado.PACIENTE_DATANASCIMENTO);
                  const cpf = formatCPF(resultado.PACIENTE_CPF);
                  const sexoLabel = resultado.PACIENTE_SEXO === 'M' ? 'Masc' : resultado.PACIENTE_SEXO === 'F' ? 'Fem' : null;

                  return (
                    <React.Fragment key={resultado.ATENDIMENTO_ID}>
                      <tr
                        onClick={() => navigate(`/resultados/${resultado.ATENDIMENTO_ID}`)}
                        style={{ cursor: 'pointer' }}
                        className="clickable-row"
                      >
                        <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '14px', textAlign: 'center' }}>
                          <span style={styles.localBadge}>{resultado.LOCAL || '-'}</span>
                        </td>
                        <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '14px' }}>
                          <div style={styles.protocolo}>{resultado.PROTOCOLO || resultado.ATENDIMENTO_ID}</div>
                          <div style={styles.protocoloSub}>ID: {resultado.ATENDIMENTO_ID}</div>
                        </td>
                        <td>
                          <div style={styles.pacienteNome}>{resultado.PACIENTE_NOME || '-'}</div>
                          <div style={styles.pacienteMeta}>
                            {cpf && <>CPF: {cpf}</>}
                          </div>
                        </td>
                        <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '14px' }}>
                          <div style={styles.dataMain}>{formatDate(resultado.DATA_ATENDIMENTO)}</div>
                          {resultado.HORARIO && <div style={styles.dataSub}>{resultado.HORARIO}</div>}
                        </td>
                        <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '16px' }}>
                          <div style={styles.progressContainer}>
                            <div style={styles.progressBar}>
                              <div style={{
                                width: `${pct}%`,
                                height: '100%',
                                backgroundColor: concluido ? '#22c55e' : pct > 0 ? '#f59e0b' : '#e5e7eb',
                                borderRadius: '3px',
                                transition: 'width 0.3s ease',
                              }} />
                            </div>
                            <span style={styles.progressText}>{totalResultados}/{totalExames}</span>
                          </div>
                        </td>
                        <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '14px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
                          <span
                            onClick={() => handleClickStatus(resultado.ATENDIMENTO_ID, resultado.PROTOCOLO)}
                            title="Ver detalhe dos exames"
                            style={concluido ? styles.badgeConcluido : styles.badgePendente}
                          >
                            {concluido ? 'Concluido' : totalPendentes === totalExames ? 'Pendente' : 'Parcial'}
                          </span>
                        </td>
                        <td rowSpan="2" style={{ verticalAlign: 'top', paddingTop: '12px' }} onClick={(e) => e.stopPropagation()}>
                          <div style={styles.btnActions}>
                            <button
                              onClick={() => navigate(`/resultados/${resultado.ATENDIMENTO_ID}`)}
                              style={styles.btnLaudo}
                            >
                              Ver Laudo
                            </button>
                            {resultado.RESULTADO_LIBERADO === 'T' && resultado.LOCAL && resultado.PROTOCOLO ? (
                              <button
                                onClick={() => handleDownloadPdf(resultado.LOCAL, resultado.PROTOCOLO)}
                                disabled={downloadingPdf[pdfKey]}
                                style={downloadingPdf[pdfKey] ? styles.btnPdfDisabled : styles.btnPdf}
                                title="Baixar PDF via plataforma online"
                              >
                                {downloadingPdf[pdfKey] ? '...' : 'PDF'}
                              </button>
                            ) : (
                              <span style={styles.btnPdfDisabled} title={resultado.RESULTADO_LIBERADO !== 'T' ? 'Resultado não liberado' : 'Local/protocolo não informado'}>
                                PDF
                              </span>
                            )}
                          </div>
                        </td>
                      </tr>
                      <tr onClick={() => navigate(`/resultados/${resultado.ATENDIMENTO_ID}`)} style={{ cursor: 'pointer' }} className="clickable-row">
                        <td style={{ borderTop: 'none', paddingTop: '0', color: '#9ca3af', fontSize: '0.8rem' }}>
                          {[sexoLabel, idade ? `${idade} anos` : null].filter(Boolean).join(' · ')}
                        </td>
                      </tr>
                    </React.Fragment>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile: Cards */}
      <div className="resultados-mobile">
        {resultados.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
            Nenhum resultado encontrado
          </div>
        ) : (
          resultados.map((resultado) => {
            const totalExames = resultado.TOTAL_EXAMES || 0;
            const totalResultados = resultado.TOTAL_RESULTADOS || 0;
            const totalPendentes = totalExames - totalResultados;
            const concluido = totalExames > 0 && totalResultados === totalExames;

            return (
              <div key={resultado.ATENDIMENTO_ID} className="resultado-card" onClick={() => navigate(`/resultados/${resultado.ATENDIMENTO_ID}`)}>
                <div className="resultado-card-header">
                  <div className="resultado-card-proto">
                    <span className="resultado-card-local">{resultado.LOCAL || '-'}</span>
                    <strong className="resultado-card-numero">{resultado.PROTOCOLO || resultado.ATENDIMENTO_ID}</strong>
                  </div>
                  <span className={`resultado-card-status ${concluido ? 'concluido' : 'pendente'}`}>
                    {concluido ? 'Concluido' : 'Pendente'}
                  </span>
                </div>
                <div className="resultado-card-paciente">{resultado.PACIENTE_NOME || '-'}</div>
                <div className="resultado-card-meta">
                  <span>{formatDate(resultado.DATA_ATENDIMENTO)}{resultado.HORARIO ? ` ${resultado.HORARIO}` : ''}</span>
                  {resultado.PACIENTE_CPF && <span>CPF: {formatCPF(resultado.PACIENTE_CPF)}</span>}
                </div>
                <div className="resultado-card-stats">
                  <span className="stat-total">{totalExames} exame{totalExames !== 1 ? 's' : ''}</span>
                  <span className="stat-pronto">{totalResultados} pronto{totalResultados !== 1 ? 's' : ''}</span>
                  {totalPendentes > 0 && <span className="stat-pendente">{totalPendentes} pendente{totalPendentes !== 1 ? 's' : ''}</span>}
                </div>
                <div className="resultado-card-actions" onClick={e => e.stopPropagation()}>
                  <button className="resultado-card-btn primary" onClick={() => navigate(`/resultados/${resultado.ATENDIMENTO_ID}`)}>
                    Ver Laudo
                  </button>
                  {resultado.RESULTADO_LIBERADO === 'T' && resultado.LOCAL && resultado.PROTOCOLO ? (
                    <button
                      className="resultado-card-btn success"
                      onClick={() => handleDownloadPdf(resultado.LOCAL, resultado.PROTOCOLO)}
                      disabled={downloadingPdf[`${resultado.LOCAL}-${resultado.PROTOCOLO}`]}
                    >
                      {downloadingPdf[`${resultado.LOCAL}-${resultado.PROTOCOLO}`] ? '...' : 'PDF'}
                    </button>
                  ) : (
                    <span className="resultado-card-btn disabled">PDF</span>
                  )}
                  <button
                    className="resultado-card-btn outline"
                    onClick={() => handleClickStatus(resultado.ATENDIMENTO_ID, resultado.PROTOCOLO)}
                  >
                    Detalhes
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Paginação */}
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalItems / itemsPerPage)}
        onPageChange={setCurrentPage}
        itemsPerPage={itemsPerPage}
        totalItems={totalItems}
      />

      {/* Modal: Detalhe de Exames */}
      {examesStatusModal && (
        <div onClick={() => setExamesStatusModal(null)} style={styles.modalOverlay}>
          <div onClick={e => e.stopPropagation()} style={styles.modalBox}>
            <div style={styles.modalHeader}>
              <h3 style={styles.modalTitle}>Exames — Protocolo {examesStatusModal.protocolo}</h3>
              <button onClick={() => setExamesStatusModal(null)} style={styles.modalClose}>&times;</button>
            </div>

            {examesStatusModal.loading ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>Carregando...</div>
            ) : examesStatusModal.exames.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>Nenhum exame encontrado</div>
            ) : (
              <table style={styles.modalTable}>
                <thead>
                  <tr>
                    <th style={styles.modalTh}>Exame</th>
                    <th style={{ ...styles.modalTh, textAlign: 'center', width: '70px' }}>Coleta</th>
                    <th style={{ ...styles.modalTh, textAlign: 'center', width: '90px' }}>Situação</th>
                    <th style={{ ...styles.modalTh, textAlign: 'center', width: '80px' }}>Resultado</th>
                  </tr>
                </thead>
                <tbody>
                  {examesStatusModal.exames.map((ex, i) => {
                    const pronto = ['D','L','I','E','A'].includes((ex.SITUACAO || '').trim());
                    const colhido = (ex.MATERIALCOLHIDO || '').trim() === 'T';
                    return (
                      <tr key={i} style={{ borderBottom: '1px solid #f3f4f6' }}>
                        <td style={styles.modalTd}>
                          <div style={{ fontWeight: '500', color: '#1e293b' }}>{ex.NOME}</div>
                          <div style={{ fontSize: '0.7rem', color: '#9ca3af' }}>{ex.CODIGO}</div>
                        </td>
                        <td style={{ ...styles.modalTd, textAlign: 'center' }}>
                          <span style={styles.modalBadge(colhido)}>{colhido ? 'Colhido' : 'Pendente'}</span>
                        </td>
                        <td style={{ ...styles.modalTd, textAlign: 'center' }}>
                          <span style={styles.modalBadge(pronto)}>{situacaoLabel(ex.SITUACAO)}</span>
                        </td>
                        <td style={{ ...styles.modalTd, textAlign: 'center' }}>
                          <span style={{ color: pronto ? '#16a34a' : '#dc2626', fontWeight: '600', fontSize: '0.78rem' }}>
                            {pronto ? 'Pronto' : 'Pendente'}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            {!examesStatusModal.loading && examesStatusModal.exames.length > 0 && (
              <div style={styles.modalFooter}>
                <span>Total: {examesStatusModal.exames.length}</span>
                <span style={{ color: '#16a34a' }}>
                  Prontos: {examesStatusModal.exames.filter(e => ['D','L','I','E','A'].includes((e.SITUACAO || '').trim())).length}
                </span>
                <span style={{ color: '#dc2626' }}>
                  Pendentes: {examesStatusModal.exames.filter(e => !['D','L','I','E','A'].includes((e.SITUACAO || '').trim())).length}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Resultados;
